import React, { memo, useMemo } from 'react';
import { validators } from 'investira.sdk';
import { Stack, Typography, CircularProgress, Divider, Box } from 'investira.react.components';

import { SearchAtivos, SearchPrincipal, SearchGlobal } from '../../../components/organisms';
import { AtivoTemplate } from '../../../components/templates';
import { useAtivosContext } from '../../../contexts/AtivosContext';

import AtivoHeader from './AtivoHeader';
import AtivoPessoa from './AtivoPessoa';
import AtivoHighlight from './AtivoHighlight';
import AtivoCotacao from './AtivoCotacao';
import AtivoRentabilidade from './AtivoRentabilidade';
import AtivoIndicesRentabilidade from './AtivoIndicesRentabilidade';
import AtivoConsistencia from './AtivoConsistencia';
import AtivoIndicadores from './AtivoIndicadores';
import AtivoProventos from './AtivoProventos';
import AtivosSemelhantes from './AtivosSemelhantes';
import AtivoCarteira from './AtivoCarteira';
import AtivoImoveis from './AtivoImoveis';
import AtivoInformacoes from './AtivoInformacoes';
import AtivoGestorAdministrador from './AtivoGestorAdministrador';
import AtivoPatrimonio from './AtivoPatrimonio';

const AtivoOverview = memo(() => {
  const { state, actions } = useAtivosContext();

  const { pessoa, ativo, cotacao, indicador, isPageLoading, isIndicadorLoading } = state;
  console.log('cotacao', cotacao);

  const { handleIndicadorChange } = actions;

  const xAtivoCotacaoData = useMemo(() => {
    return [
      {
        ativo: ativo.ticker,
        data: cotacao.historico.full
      }
    ];
  }, [ativo.ticker, cotacao.historico.full]);

  const xAtivoRentabilidadeData = useMemo(() => {
    return [
      {
        ativo: ativo?.ticker,
        data: cotacao.historico
      },
      {
        ativo: indicador.current,
        data: indicador.historico
      }
    ];
  }, [ativo.ticker, cotacao.historico, indicador]);

  if (isPageLoading) {
    return (
      <Stack sx={{ height: '100%' }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <CircularProgress />
        </Stack>
      </Stack>
    );
  }

  if (validators.isEmpty(ativo)) {
    return (
      <Stack sx={{ height: '100%' }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <Typography variant="body2" color="textSecondary">
            Ativo não encontrado
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return (
    <AtivoTemplate
      title={`${ativo.ticker || ativo.isin || ''} (${ativo.ativo || ''}) - ${
        pessoa.pessoa_fantasia || ''
      }`}
      header={<AtivoHeader compare={false} />}
      description={`Descubra tudo sobre ${ativo.ticker || ativo.isin} do ${
        pessoa.pessoa_fantasia
      }: cotações, gráficos detalhados, resultados, dividendos, análises, balanços e indicadores financeiros. Acompanhe as últimas notícias e fatos relevantes para tomar decisões de investimento informadas.`}
      searchComponent={<SearchGlobal />} //SearchAtivos
      maxWidth="xl"
      ativo={ativo}>
      <Stack py={2}>
        <Divider />
      </Stack>

      <Stack gap={4}>
        <AtivoGestorAdministrador pessoa={pessoa} ativo={ativo} />
        <AtivoHighlight cotacao={cotacao} ativo={ativo} />
        <AtivoCotacao cotacoes={xAtivoCotacaoData} ativo={ativo} />
        <AtivoRentabilidade
          cotacoes={xAtivoRentabilidadeData}
          actions={{
            handleIndicadorChange
          }}
        />
        <AtivoIndicesRentabilidade />
        <AtivoConsistencia pessoa={pessoa} ativo={ativo} cotacao={cotacao} />
        <AtivoPatrimonio pessoa={pessoa} />
        <AtivoIndicadores pessoa={pessoa} ativo={ativo} cotacao={cotacao} />
        <AtivoProventos pessoa={pessoa} ativo={ativo} />
        <AtivoCarteira ativo={ativo} />
        <AtivoImoveis ativo={ativo} />

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              lg: 'repeat(2, 1fr)'
            },
            gap: 4
          }}>
          <AtivoInformacoes ativo={ativo} pessoa={pessoa} />
          <AtivoPessoa pessoa={pessoa} />
        </Box>

        <AtivosSemelhantes ativo={ativo} />
      </Stack>
    </AtivoTemplate>
  );
});

export default AtivoOverview;
